const FormFieldGroupKeys = {
  IS_SMART_GROUP: 'isSmartGroup',
  FIELDS: 'fields',
  DEFAULT: 'default',
  RICH_TEXT: 'richText',
  IS_PAGE_BREAK: 'isPageBreak'
};
export default FormFieldGroupKeys;